import {BaseDataProvider} from "./BaseDataProvider";
import {SurveyCampaignListOptions} from "../model/SurveyCampaignListOptions";
import {SurveyCampaignModel} from "../model/SurveyCampaignModel";

export class SurveyCampaignDataProvider
    extends BaseDataProvider<SurveyCampaignModel, SurveyCampaignListOptions> {
    constructor() {
        super(`/survey/campaigns`);
    }

    getInsertData = (data: SurveyCampaignModel): any => {
        const req = {...data} as any;
        req.formId = req.form?.id;
        delete req.form;
        delete req.created;
        delete req.state;
        return req;
    }


    getUpdateData = (id: string, data: SurveyCampaignModel): any => {
        const req = this.getInsertData(data);
        delete req.id;
        delete req.created;
        delete req.state;
        return req;
    }

    mapModel = (model: any): SurveyCampaignModel => {
        return {...model, startDate: new Date(model.startDate), endDate: new Date(model.endDate)};
    }

}